export default "__VITE_ASSET__BEcQtun9__"